'use client'

import { CMSLink } from '@/components/Link'
import Link from 'next/link'
import { useRouter } from 'next/navigation'
import { ChevronsRight } from 'lucide-react'
import SubMenu from './sub-menu'

export const Header2 = ({
  navItems,
  logo,
  rightCta,
}: {
  navItems: any
  logo: any
  rightCta?: any
}) => {
  const { push } = useRouter()

  return (
    <div className="bg-primary py-6 px-4 shadow-md font-sans">
      <div className="max-w-7xl mx-auto flex items-center space-x-24">
        {logo?.url && (
          <img
            src={logo?.url}
            alt="Titan Fence & Supply Company - Est. 2009 - Crossroads, Texas"
            className="w-32 h-auto cursor-pointer"
            onClick={() => {
              push('/')
            }}
          />
        )}

        <div className="flex items-center gap-8 flex-1 justify-center border border-border rounded-full">
          {navItems?.map((item: any, index: any) => {
            return (
              <div
                className="text-left cursor-pointer relative group py-[18px]"
                key={`index-${index}-${item?.link?.label}`}
              >
                <Link
                  href={item?.link?.url || '/'}
                  className="flex items-center px-5 py-1 text-lg font-medium capitalize text-primary-foreground rounded-[17px] relative z-[1] transition-all duration-500"
                >
                  <h3 className="text-base text-primary-foreground transition-colors group">
                    {item?.link?.label}
                  </h3>

                  <span className="absolute inset-0 bg-destructive rounded-[17px] scale-x-0 group-hover:scale-x-100 transition-transform z-[-1] w-full" />
                </Link>

                {!!item?.subMenuItems?.length && <SubMenu items={item?.subMenuItems} />}
              </div>
            )
          })}
        </div>
        {rightCta &&
          rightCta?.map((item: any, index: any) => {
            return (
              <div
                className="relative overflow-hidden group rounded-full inline-flex"
                key={item?.id || index}
              >
                <CMSLink
                  {...item.link}
                  className="relative z-10 inline-flex items-center border border-border hover:border-destructive cursor-pointer text-primary-foreground font-semibold text-base tracking-wide transition-all duration-500 ease-out rounded-full px-6 py-8 bg-background hover:bg-destructive"
                >
                  <div className="w-12 h-12 rounded-full flex items-center justify-center ml-2 bg-destructive text-background group-hover:bg-background group-hover:text-destructive">
                    <ChevronsRight />
                  </div>
                </CMSLink>

                <div className="absolute inset-0 bg-destructive origin-center rotate-[-45deg] scale-y-0 group-hover:scale-y-[5] transition-transform duration-500 ease-in-out rounded-full z-0" />
              </div>
            )
          })}
      </div>
    </div>
  )
}
